import {
  getData,
  postData,
  patchData,
  deleteData
} from './Services'

export const getBannersPanel = async (searchTerm, page, perPage) => {
  let queryParams = [];

  if (searchTerm) {
    queryParams.push(`descripcion=${encodeURIComponent(searchTerm || '')}`);
  }
  if (page) {
    queryParams.push(`page=${encodeURIComponent(page)}`);
  }
  if (perPage) {
    queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
  }
  const queryString = queryParams.length > 0 ? `?}&${queryParams.join('&')}` : '';

  return await getData("/banners/banners_panel", queryString);
};

export const getBannerById = async (id) => {
  const res = await getData(`/banners/${id}`)
  return res
}


export const postBanner = async (body) => {
  const res = await postData('/banners', body)
  return res
}

export const patchBanner = async (id, body) => {
  const res = await patchData(`/banners/${id}`, body)
  return res
}

export const deleteBanner = async (id) => {
  const res = await deleteData(`/banners/${id}`)
  return res
}